import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { createKey } from "../Shared/utils/createKey";
const AddressCardSkeleton = ({ perRow }) => (_jsx(Grid, Object.assign({ item: true, xx: perRow[0], sm: perRow[1], md: perRow[2] }, { children: _jsx(Skeleton, { variant: "rectangular", height: "160px" }) })));
/**
 *
 * @param numberOfSkeletons
 * @param perRow Array of numbers for grid screen size config.
 * @returns
 */
export const AddressCardLoadingSkeletons = ({ numberOfSkeletons = 6, perRow = [12, 6, 4], }) => {
    const skellyArray = Array.from(Array(numberOfSkeletons).keys());
    return (_jsx(Grid, Object.assign({ container: true, spacing: 2 }, { children: skellyArray.map((s) => (_jsx(AddressCardSkeleton, { perRow: perRow }, createKey()))) })));
};
